import api, { METHODS } from './api'
import { BlockHTMLPipesVariables, BlockHTMLPipesVariablesResponse, BlocksPipes } from '../common/types/api/page'
import { Recipient } from '../common/types/form'

export async function getHTMLPipesVariables(HTMLPipesConfig: BlocksPipes): Promise<BlockHTMLPipesVariables> {
    try {
        const res = await api<BlockHTMLPipesVariablesResponse>(
            `preview/htmlpipes`,
            METHODS.POST,
            JSON.stringify(HTMLPipesConfig)
        )
        if (!res.success) {
            console.error(res)
        }

        return res.htmlPipesVariables || {}
    } catch (error) {
        console.error(error)

        return {}
    }
}

interface PreviewHTMLPipes {
    blockPipes: BlocksPipes
    recipient?: Recipient
}
export async function getHTMLPipesRaw(config: PreviewHTMLPipes): Promise<string> {
    try {
        const res = await api<{
            success: boolean
            config: string
            count: number
        }>(`preview/htmlpipesRaw`, METHODS.POST, JSON.stringify(config))
        if (!res.success) {
            console.error(res)
        }

        return res.config || ''
    } catch (error) {
        console.error(error)

        return ''
    }
}
